import service from './service.js';
export default {
  props: {
    applyReparams: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      cboxFlag: false
    };
  },
  methods: {
    cancelExtend () {
      this.cboxFlag = false;
      this.$emit('update:applyReparams', {});
    },
    // 确认
    confirmSubmit () {
      service.applyRevocation(this.applyReparams.bidId).then(({code, reason}) => {
        if (code === '0') {
          this.$successMessage('撤销成功');
          this.cancelExtend();
          this.$emit('getResultList');
        } else {
          this.$errorMessage(reason);
          this.cancelExtend();
        }
      }).catch(error => {
        if (error && error.data && error.data.reason) {
          this.$errorMessage(error.data.reason);
        } else {
          this.$errorMessage('撤销失败');
        }
        this.cancelExtend();
      });
    }
  }
};
